"use client";

import { c as _c } from "react/compiler-runtime";
import type { AllowlistDescription } from "@/components/allowlist-tool/allowlist-tool.types";
import AllowlistToolLoader from "@/components/allowlist-tool/common/AllowlistToolLoader";
import { distributionPlanApiDelete } from "@/services/distribution-plan-api";
import { useRouter } from "next/navigation";
import { useState } from "react";
export default function DistributionPlanToolPlansTableItem(t0) {
  const $ = _c(28);
  const {
    plan,
    onDeleted
  } = t0;
  const router = useRouter();
  let t1;
  if ($[0] !== router) {
    t1 = id => {
      router.push(`/emma/plans/${id}`);
    };
    $[0] = router;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const goToDistributionPlan = t1;
  const getDate = _temp;
  const date_0 = getDate(plan.createdAt);
  const [loadingDelete, setLoadingDelete] = useState(false);
  let t2;
  if ($[2] !== onDeleted || $[3] !== plan.id) {
    t2 = async () => {
      setLoadingDelete(true);
      const endpoint = `/allowlists/${plan.id}`;
      const {
        success
      } = await distributionPlanApiDelete({
        endpoint
      });
      if (success) {
        onDeleted(plan.id);
        return;
      }
      setLoadingDelete(false);
    };
    $[2] = onDeleted;
    $[3] = plan.id;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const onDelete = t2;
  let t3;
  if ($[5] !== goToDistributionPlan || $[6] !== plan.id) {
    t3 = () => goToDistributionPlan(plan.id);
    $[5] = goToDistributionPlan;
    $[6] = plan.id;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== plan.name) {
    t4 = <td className="tw-whitespace-nowrap tw-px-3 tw-py-4 tw-text-xs tw-font-normal tw-text-iron-300 sm:tw-pl-6">{plan.name}</td>;
    $[8] = plan.name;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== plan.description) {
    t5 = <td className="tw-whitespace-nowrap tw-px-3 tw-py-4 tw-text-xs tw-font-normal tw-text-iron-300">{plan.description}</td>;
    $[10] = plan.description;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== date_0) {
    t6 = <td className="tw-whitespace-nowrap tw-px-3 tw-py-4 tw-text-xs tw-font-normal tw-text-iron-300">{date_0}</td>;
    $[12] = date_0;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== onDelete) {
    t7 = e => {
      e.stopPropagation();
      onDelete();
    };
    $[14] = onDelete;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== loadingDelete) {
    t8 = loadingDelete ? <AllowlistToolLoader /> : <svg className="tw-h-4 tw-w-4 group-hover:tw-text-error tw-transition tw-duration-300 tw-ease-out" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 3H15M3 6H21M19 6L18.2987 16.5193C18.1935 18.0975 18.1409 18.8867 17.8 19.485C17.4999 20.0118 17.0472 20.4353 16.5017 20.6997C15.882 21 15.0911 21 13.5093 21H10.4907C8.90891 21 8.11803 21 7.49834 20.6997C6.95276 20.4353 6.50009 20.0118 6.19998 19.485C5.85911 18.8867 5.8065 18.0975 5.70129 16.5193L5 6M10 10.5V15.5M14 10.5V15.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[16] = loadingDelete;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== loadingDelete || $[19] !== t7 || $[20] !== t8) {
    t9 = <td className="tw-whitespace-nowrap tw-px-3 tw-py-4 tw-text-xs tw-text-right tw-font-normal tw-text-iron-300 sm:tw-pr-6"><button onClick={t7} disabled={loadingDelete} type="button" title="Delete" className="tw-rounded-full tw-group tw-p-2 tw-text-xs tw-font-medium tw-border-none tw-ring-1 tw-ring-inset tw-text-iron-400 tw-bg-iron-400/10 tw-ring-iron-400/20">{t8}</button></td>;
    $[18] = loadingDelete;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t3 || $[23] !== t4 || $[24] !== t5 || $[25] !== t6 || $[26] !== t9) {
    t10 = <tr onClick={t3} className="tw-cursor-pointer hover:tw-bg-iron-800/60 tw-transition tw-duration-300 tw-ease-out">{t4}{t5}{t6}{t9}</tr>;
    $[22] = t3;
    $[23] = t4;
    $[24] = t5;
    $[25] = t6;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  return t10;
}
function _temp(timestamp) {
  const date = new Date(timestamp);
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear().toString().slice(-2);
  return `${day}/${month}/${year}`;
}